import axios from 'axios';

export interface EmailFileAttachment {
  filename: string;
  content: string;
  contentType: string;
}

export async function getBase64ConversionFromUrl(
  input:
    | { url: string; filename: string; contentType: string }
    | { url: string; filename: string; contentType: string }[]
): Promise<EmailFileAttachment[]> {
  try {
    const files = Array.isArray(input) ? input : [input];

    const fileAttachments = await Promise.all(
      files.map(async ({ url, filename, contentType }) => {
        const response = await axios.get(url, { responseType: 'arraybuffer' });
        const buffer = Buffer.from(response.data, 'binary');

        return {
          filename,
          content: buffer.toString('base64'),
          contentType,
        };
      })
    );

    return fileAttachments;
  } catch (error) {
    console.error('Error downloading files:', error);
    throw error;
  }
}
